import { Mutation, Action } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';

@InjectModule({ stateFactory: true }, module)
export default class SourceModule extends InjectVuexModule {

    defaultSourceId = 0;
    defaultSource = 'general';

    id = this.defaultSourceId;
    source = this.defaultSource;

    @Mutation
    public setSourceId(sourceId: number) {
        this.id = sourceId;
    }

    @Mutation
    public setSource(source: string) {
        this.source = source;
    }

    @Action({ rawError: true })
    public async clearStore() {
        this.setSource(this.defaultSource);
        this.setSourceId(this.defaultSourceId);
    }
}
